import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import {
  Button,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {KeyboardDatePicker} from '@material-ui/pickers';
import CouponTable from '../../components/CouponTable';
import styles from './styles.module.css';
import api from '../../core/api';
import DateRangeFilter from '../../components/DataRange';
import {GetData} from '../../utils/Storage';
import Business from '../../models/Business';

const style = {
  flexEnd: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  datePicker: {
    width: '100%',

    borderRadius: '4px',
    display: 'flex',

    gap: '2rem',
  },
};

const CouponsPage = ({history}) => {
  const [allCoupons, setAllCoupons] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [isLoading, setLoading] = useState(true);
  const [couponCodeFilter, setCouponCodeFilter] = useState('');
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [expirationDateFilter, setExpirationDateFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [error, setError] = useState(false);

  const [getEmpresas, setEmpresas] = useState([]);
  const [selectEmpresa, setSelectEmpresa] = useState('');
  const user = GetData('business');
  const fetchEmpresa = async () => {
    try {
      const allEmpresas = await Business.findAll();
      setEmpresas(allEmpresas);
    } catch (e) {
      // console.log({e});
    }
  };
  useEffect(() => {
    fetchEmpresa();

    if (!user.adminMaster) {
      setSelectEmpresa(user.business_id);
      fetchCoupons();
    }
  }, []);

  const handleFilterChange = event => {
    setCouponCodeFilter(event.target.value);
  };

  async function fetchCoupons() {
    setLoading(true);
    const filters = {
      couponCode: couponCodeFilter,
      businessId: selectEmpresa,
      startDate: startDateFilter,
      endDate: endDateFilter,
      expirationDate: expirationDateFilter,
      status: statusFilter,
    };

    try {
      const {data} = await api.get('coupons', {params: {filters}});
      setAllCoupons(data);
      setError(false);
    } catch (err) {
      setError(true);
    } finally {
      setFirstLoading(false);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCoupons();
  }, [
    couponCodeFilter,
    endDateFilter,
    startDateFilter,
    expirationDateFilter,
    statusFilter,
    selectEmpresa,
  ]);

  if (error) {
    return (
      <div>
        <p style={{textAlign: 'center'}}>Ocorreu um erro ao obter os dados.</p>
        <p style={{textAlign: 'center'}}>
          <a href="javascript:void(0)" onClick={fetchCoupons}>
            Tentar novamente
          </a>
        </p>
      </div>
    );
  }

  return (
    <Dashboard>
      {firstLoading ? (
        <div className="flex-col center-a center-b" style={{height: '50vh'}}>
          <span style={{paddingTop: '10em'}}>
            <CircularProgress size={100} />
            <p> Carregando... </p>
          </span>
        </div>
      ) : (
        <div style={{overflow: 'hidden'}}>
          <div className={styles['filter-bar']}>
            <TextField
              style={{width: '30%'}}
              variant="outlined"
              label="Buscar Por Código"
              value={couponCodeFilter}
              onChange={handleFilterChange}
            />

            <TextField
              style={{width: '20%'}}
              margin="none"
              variant="outlined"
              type="date"
              label="Data de Expiração"
              value={expirationDateFilter}
              InputLabelProps={{shrink: true}}
              onChange={dateForm => {
                setExpirationDateFilter(dateForm.target.value);
              }}
            />
            <FormControl style={{width: '20%'}}>
              <InputLabel>Selecione a empresa</InputLabel>

              <Select
                variant="outlined"
                value={selectEmpresa}
                label="Selecione a empresa"
                disabled={!user.adminMaster}
                onChange={e => setSelectEmpresa(e.target.value)}>
                {getEmpresas && [
                  <MenuItem value={null}>Todos</MenuItem>,
                  ...getEmpresas.map(e => {
                    return <MenuItem value={e.id}>{e.corporateName}</MenuItem>;
                  }),
                ]}
              </Select>
            </FormControl>

            <FormControl style={{width: '20%'}}>
              <InputLabel
                id="subscription-type-label"
                style={{paddingLeft: '15px'}}>
                Status
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                defaultValue={null}
                value={statusFilter}
                onChange={event => setStatusFilter(event.target.value)}>
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="active">Ativo</MenuItem>
                <MenuItem value="inactive">Inativo</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{display: 'flex', justifyContent: 'end', width: '100%'}}>
            {user.adminMaster && (
              <Button
                sx={{borderRadius: 10}}
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => history.push(`${window.location.pathname}/add`)}>
                Novo Cupom
              </Button>
            )}
          </div>
          {isLoading ? (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em'}}>
                <CircularProgress size={100} />
                <p> Carregando... </p>
              </span>
            </div>
          ) : allCoupons.length <= 0 ? (
            <div
              style={{
                display: 'flex',
                marginBottom: '10px',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <p
                style={{
                  fontSize: '1.1876rem',
                  color: '#b1a4aa',
                }}>
                Nenhum cupom encontrado.
              </p>
            </div>
          ) : (
            <div style={{marginTop: '2rem'}}>
              <CouponTable coupons={allCoupons} />
            </div>
          )}
        </div>
      )}
    </Dashboard>
  );
};

export default CouponsPage;
